module.exports = __webpack_public_path__ + "teqbahn-assets/media/4.ca817a57.png";